import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className="Loader">
      <div className="overlay-container">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;
